<template>
  <div class="card">
    <div class="card-header">
      <i class="icon-target"></i> Coachs

      <button
        v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
        type="button"
        class="btn btn-sm btn-danger float-right"
        :disabled="loading"
        @click="deleteAttribution()"
      >
        <i class="icon-close"></i> Terminer l'attribution
      </button>

      <button
        type="button"
        class="btn btn-sm btn-primary float-right"
        @click="showWaitingCoachList"
      >
        {{
          isWaitingCoachsList
            ? "Liste de tous les coachs"
            : "Liste des coachs en attente"
        }}
        <i
          v-if="!isWaitingCoachsList"
          class="fa fa-info-circle ml-05"
          v-tooltip="{
            content: `Afficher tous les coachs en attente de réponse et ayant pour statut 'Actif', 'Inactif' ou 'Recruté'`,
            placement: 'top',
          }"
        ></i>
      </button>
    </div>
    <div class="card-block">
      <div class="row">
        <div class="col-sm-5">
          <div class="form-group">
            <label class="control-label">Filtrer par appli : </label>
            <select
              v-model="form.filterAppli"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </div>

          <div class="form-group">
            <label class="control-label">Filtrer par genre :</label>
            <select
              v-model="form.filterGender"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option :value="null">Tout</option>
              <option value="Homme">Homme</option>
              <option value="Femme">Femme</option>
            </select>
          </div>

          <div class="form-group" v-if="attributionCoachStatus">
            <label class="control-label">Filtrer par statut :</label>
            <multiselect
              placeholder="Choisir des valeurs"
              v-model="form.filterStatus"
              :options="attributionCoachStatus"
              label="label"
              track-by="label"
              class="custom-multiselect"
              :multiple="true"
              @input="refreshCoachs()"
            >
            </multiselect>
          </div>

          <div class="form-group">
            <label class="control-label"
              >Coachs sportifs uniquement :
              <i
                class="fa fa-info-circle ml-05"
                v-tooltip="{
                  content:
                    'Permet de filtrer les prestataires qui ne sont pas à proprement parler des coachs sportifs (ex: masseurs, diététiciens, profs de méditation, etc.)',
                  placement: 'right',
                }"
              ></i>
            </label>
            <select
              v-model="form.filterSportsCoachOnly"
              v-on:change="refreshCoachs"
              class="form-control"
            >
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </div>

          <div class="form-group" v-if="prestations">
            <label class="control-label">Filtrer par prestation :</label>
            <multiselect
              placeholder="Choisir des valeurs"
              v-model="form.filterPrestation"
              :options="prestations"
              label="label"
              track-by="label"
              class="custom-multiselect"
              :multiple="true"
              @input="refreshCoachs"
            >
            </multiselect>
          </div>

          <div class="form-group" v-if="tags">
            <label class="control-label">Filtrer par tags :</label>
            <multiselect
              placeholder="Choisir des valeurs"
              v-model="form.filterTags"
              :options="tags"
              label="label"
              track-by="label"
              class="custom-multiselect"
              :multiple="true"
              @input="refreshCoachs()"
            >
            </multiselect>
          </div>

          <div class="form-group" v-if="langs">
            <label class="control-label">Filtrer par langues :</label>
            <select
              v-model="form.filterLang"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option :value="null">Aucune</option>
              <option v-for="lang in langs" :key="lang.name" :value="lang.name">
                {{ lang.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label class="control-label">Activer la disponibilité</label>
            <select
              v-model="form.filterAvailability"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </div>
          <div class="form-group" v-if="form.filterAvailability === '1'">
            <div class="row">
              <div class="col-sm-4">
                <label class="control-label">Jour</label>
                <select v-model="period.index" class="form-control">
                  <option :value="0">Lundi</option>
                  <option :value="1">Mardi</option>
                  <option :value="2">Mercredi</option>
                  <option :value="3">Jeudi</option>
                  <option :value="4">Vendredi</option>
                  <option :value="5">Samedi</option>
                  <option :value="6">Dimanche</option>
                </select>
              </div>
              <div class="col-sm-3">
                <label class="control-label">Début</label>
                <select v-model="period.start" class="form-control">
                  <option
                    v-for="hour in [
                      6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                      21, 22, 23,
                    ]"
                    :key="hour"
                    :value="hour"
                  >
                    {{ hour }}:00
                  </option>
                </select>
              </div>
              <div class="col-sm-3">
                <label class="control-label">Fin</label>
                <select v-model="period.end" class="form-control">
                  <option
                    v-for="hour in [
                      6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                      21, 22, 23,
                    ]"
                    :key="hour"
                    :value="hour"
                  >
                    {{ hour }}:00
                  </option>
                </select>
              </div>
              <div class="col-sm-1">
                <label class="control-label">&nbsp;</label>
                <button
                  class="btn btn-primary"
                  @click="addPeriod"
                  :disabled="
                    !hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')
                  "
                >
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>
            <template v-if="form.periods">
              <div
                class="row periods"
                v-for="(period, index) in form.periods"
                :key="index"
              >
                <div class="col-sm-4">
                  <label class="control-label"
                    ><strong>{{ indexToDay(period.index) }}</strong></label
                  >
                </div>
                <div class="col-sm-6">
                  <label class="control-label"
                    ><strong
                      >{{ period.start }}:00 &rarr; {{ period.end }}:00</strong
                    ></label
                  >
                </div>
                <div class="col-sm-1">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="removePeriod(index)"
                    :disabled="
                      !hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')
                    "
                  >
                    <i class="icon-close"></i>
                  </button>
                </div>
              </div>
            </template>
          </div>

          <div class="form-group">
            <label class="control-label">Activer le rayon d'action</label>
            <select
              v-model="form.filterDelayed"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option value="1">Oui</option>
              <option value="0">Non</option>
            </select>
          </div>

          <div class="form-group" v-if="form.filterDelayed === '1'">
            <label class="control-label">Zone étendue</label>
            <select
              v-model="form.filterRangeExtension"
              v-on:change="refreshCoachs()"
              class="form-control"
            >
              <option value="0">+0 km</option>
              <option value="30">+30 km</option>
              <option value="50">+50 km</option>
            </select>
          </div>

          <div class="form-group" v-if="order && setCredit">
            <label>Credit <u>par séances</u></label>
            <div class="row">
              <div class="col-sm-6">
                <select
                  v-model="form.credit"
                  @input="updateCredit()"
                  class="form-control"
                >
                  <option value="0">0€</option>
                  <option value="15.00">15.00€</option>
                  <option value="20.00">20.00€</option>
                  <option value="27.50">27.50€</option>
                  <option value="30">30€</option>
                  <option value="32.50">32.50€</option>
                  <option value="manual">Autre</option>
                </select>
              </div>
              <div class="input-group col-sm-6" v-if="form.credit == 'manual'">
                <input
                  v-model="form.creditManual"
                  type="text"
                  @input="updateCredit()"
                  class="form-control"
                />
                <span class="input-group-addon"
                  ><i class="fa fa-euro"></i
                ></span>
              </div>
            </div>
            <div class="row py-2">
              <div
                class="col d-flex justify-content-between align-items-start flex-wrap"
                style="gap: 0.5rem"
              >
                <div class="d-flex flex-wrap" style="gap: 0.5rem">
                  <button
                    v-if="
                      hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')
                    "
                    class="btn btn-sm btn-primary"
                    :disabled="refreshing || loading"
                    @click="refreshCoachs"
                  >
                    <i class="fa fa-refresh"></i>
                    <span class="hidden-md-down"> Rafraichir</span>
                  </button>
                  <button
                    v-if="
                      hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')
                    "
                    class="btn btn-sm btn-danger"
                    :disabled="loading"
                    @click="cleanCoachs"
                  >
                    <i class="icon-trash"></i>
                    <span class="hidden-md-down"> Clean Coachs</span>
                  </button>
                </div>

                <button
                  v-if="
                    coachs &&
                    coachs.available &&
                    coachs.available.length &&
                    hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')
                  "
                  :disabled="loading"
                  class="btn btn-sm btn-secondary"
                  @click="addSelectedCoachs"
                >
                  <i class="icon-plus"></i> Ajouter tous les coachs
                </button>
              </div>
            </div>
            <p>
              Pour cette commande la séance est à
              {{ formatPrice(order.price / order.session) || "**" }} TTC.
            </p>
          </div>

          <AttributionReminderOptions
            v-if="hasPermission($store.state.user, 'ATTRIBUTIONS_WRITE')"
            class="mt-3"
            :attribution="attribution"
            :coachs="isWaitingCoachsList ? selectedWaitingCoach : queuedCoachs"
            :credit="form.creditManual"
            :order="order"
            @smsReminderSent="$emit('smsReminderSent')"
            @emailReminderSent="$emit('emailReminderSent')"
          />
        </div>
        <div class="col-sm-7">
          <table class="table table-condensed">
            <thead v-if="refreshing">
              <th class="d-block text-center">
                Chargement des coachs en cours ...
              </th>
            </thead>
            <template v-else>
              <thead>
                <tr>
                  <th class="text-center" v-if="coachs">
                    <h5>
                      {{ coachsTotal }} coachs
                      <i
                        class="fa fa-info-circle ml-05"
                        v-tooltip="{
                          content:
                            'Sont exclus des stats les séances découvertes, les events, les commandes ayant pour commercial “Marchés Publics”, les commandes B2B et les commandes “autres”.',
                          placement: 'top',
                        }"
                      ></i>
                    </h5>
                    <p>
                      <span
                        v-if="acceptedCoachs.length"
                        class="text-success count-info"
                      >
                        <i class="icon-user-following"></i>
                        {{ acceptedCoachs.length }}
                      </span>
                      <span
                        v-if="rejectedCoachs.length"
                        class="text-danger count-info"
                      >
                        <i class="icon-user-unfollow"></i>
                        {{ rejectedCoachs.length }}
                      </span>
                      <span
                        v-if="queuedCoachs.length && !isWaitingCoachsList"
                        class="text-info count-info"
                      >
                        <i class="icon-user-following"></i>
                        {{ queuedCoachs.length }}
                      </span>
                      <span
                        v-if="coachsWaiting.length && isWaitingCoachsList"
                        class="text-info count-info"
                      >
                        <i class="icon-user-following"></i>
                        {{ coachsWaiting.length }}
                      </span>
                      <span v-if="availableCoachs.length" class="count-info">
                        <i class="icon-user"></i>
                        {{ availableCoachs.length }}
                      </span>
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>
                    <div class="d-flex justify-content-between">
                      <input
                        class="form-control"
                        v-model="filterCoach"
                        placeholder="Filtrer par nom"
                        type="text"
                      />

                      <input
                        v-if="isWaitingCoachsList"
                        class="form-control ml-1"
                        v-model="filterWaitingCoachByDistance"
                        placeholder="Filtrer par distance"
                        type="number"
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="pt-1">
                <template v-if="!isWaitingCoachsList">
                  <AttributionFiltersCoach
                    v-for="coach in acceptedCoachs"
                    :key="coach.id"
                    :coach="coach"
                    :credit="filteredCredit"
                    :accepted="true"
                    @openRejectReasonModal="
                      openRejectReasonModal(coach, 'unassign')
                    "
                    @assign="assignCoach(coach, filteredCredit)"
                  />
                  <AttributionFiltersCoach
                    v-for="coach in rejectedCoachs"
                    :key="coach.id"
                    :coach="coach"
                    :credit="filteredCredit"
                    :rejected="true"
                  />
                  <AttributionFiltersCoach
                    v-for="coach in queuedCoachs"
                    :key="coach.id"
                    :coach="coach"
                    :credit="filteredCredit"
                    :queued="true"
                    @force="assignCoachConfirm(coach, filteredCredit)"
                    @openRejectReasonModal="openRejectReasonModal(coach)"
                  />
                  <AttributionFiltersCoach
                    v-for="coach in availableCoachs"
                    :key="coach.id"
                    :coach="coach"
                    :credit="filteredCredit"
                    @add="addCoach(coach)"
                  />
                </template>

                <AttributionFiltersCoach
                  v-else
                  v-for="coach in coachsWaiting"
                  :key="coach.id"
                  :coach="coach"
                  :credit="filteredCredit"
                  :waiting="isWaitingCoachsList"
                  @force="assignCoachConfirm(coach, filteredCredit)"
                  @openRejectReasonModal="openRejectReasonModal(coach)"
                  @addOrDeleteCoach="addOrDeleteCoachWaitingList"
                />
              </tbody>
            </template>
          </table>
        </div>
      </div>
    </div>

    <ModalRejectAttributionReason
      :isShow="isRejectReasonModalOpen"
      :attributionId="attribution.id"
      :coachEmailToReject="coachEmailToReject"
      :rejectType="rejectType"
      @close="isRejectReasonModalOpen = false"
      @unassign="unassignCoach"
      @remove="removeCoach"
    />
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";

import Langs from "@/assets/json/langs.json";
import AttributionFiltersCoach from "@/components/attribution//AttributionFiltersCoach";
import AttributionReminderOptions from "@/components/attribution/AttributionReminderOptions";
import ModalRejectAttributionReason from "@/components/modal/ModalRejectAttributionReason.vue";

export default {
  components: {
    AttributionFiltersCoach,
    Multiselect,
    AttributionReminderOptions,
    ModalRejectAttributionReason,
  },

  props: {
    attribution: {
      type: Object,
      default: null,
    },
    order: {
      type: Object,
      default: null,
    },
    client: {
      type: Object,
      default: null,
    },
    clientAttributions: {
      type: Array,
      default: null,
    },
    setCredit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      refreshing: false,
      loading: false,
      prestations: [],
      tags: [],
      coachs: {
        queue: [],
        accepted: [],
        rejected: [],
        available: [],
        waiting: [],
      },
      filterCoach: null,
      form: {
        filterDelayed: "1",
        filterAppli: "0",
        filterGender: null,
        filterStatus: [],
        filterSportsCoachOnly: "1",
        filterPrestation: [],
        filterTags: [],
        filterLang: null,
        credit: "20.00",
        creditManual: "0.00",
        filterAvailability: "0",
        periods: null,
        filterRangeExtension: "0",
      },
      period: {
        index: 0,
        start: null,
        end: null,
      },
      isWaitingCoachsList: false,
      filterWaitingCoachByDistance: undefined,
      coachsWaiting: [],
      isRejectReasonModalOpen: false,
      coachEmailToReject: "",
      rejectType: null,
    };
  },

  async created() {
    const { data } = await this.$api.get("/settings");

    if (data["intervenants_prestations"]) {
      this.prestations = data["intervenants_prestations"].map((prestation) => ({
        label: prestation,
        value: prestation,
      }));
    }

    if (data["intervenants_tags"]) {
      this.tags = data["intervenants_tags"].map((tag) => ({
        label: tag,
        value: tag,
      }));
    }

    if (this.attribution.filters) {
      this.form.filterAppli = this.attribution.filters.appli ? "1" : "0";
      this.form.filterGender = this.attribution.filters.gender;
      this.form.filterSportsCoachOnly = this.attribution.filters.sportsCoachOnly
        ? "1"
        : "0";
      this.form.filterPrestation = this.attribution.filters.prestations
        ? this.attribution.filters.prestations.map((t) => ({
            label: t,
            value: t,
          }))
        : [];
      this.form.filterTags = this.attribution.filters.tags
        ? this.attribution.filters.tags.map((t) => ({ label: t, value: t }))
        : [];
      this.form.filterLang = this.attribution.filters.lang;
      this.form.filterDelayed = this.attribution.filters.range ? "1" : "0";
      this.form.filterAvailability = this.attribution.filters.availability
        ? "1"
        : "0";
      this.form.periods = this.attribution.filters.periods;

      if (this.attribution.filters.rangeExtension !== undefined) {
        this.form.filterRangeExtension = String(
          this.attribution.filters.rangeExtension,
        );
      }

      if (this.setCredit && undefined !== this.attribution.filters.credit) {
        this.form.credit = "manual";
        this.form.creditManual = (
          this.attribution.filters.credit / 100
        ).toFixed(2);
      }

      if (this.attribution.filters.status?.length > 0) {
        this.attribution.filters.status.forEach((status) => {
          if (!this.form.filterStatus.some((s) => s.value === status)) {
            const statusToPush = this.attributionCoachStatus.find(
              (s) => s.value === status,
            );

            if (statusToPush) {
              this.form.filterStatus.push(statusToPush);
            }
          }
        });
      }
    }

    this.refreshCoachs();
  },

  watch: {
    clientAttributions() {
      this.updateAttributedCoachs();
    },

    filterCoach(val) {
      this.filteredCoachsWaiting(this.coachs.waiting, val);
    },

    filterWaitingCoachByDistance(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.waitingCoachList(this.coachs.queue);
      }
    },
  },

  computed: {
    ...mapGetters({
      coachStatus: "getCoachStatus",
    }),

    attributionCoachStatus() {
      return this.coachStatus.filter(
        ({ value }) => value !== "suspended" && value !== "imported",
      );
    },

    langs() {
      return Langs;
    },

    queuedCoachs() {
      return this.filteredAttributionCoachs(this.coachs.queue);
    },

    acceptedCoachs() {
      return this.filteredAttributionCoachs(this.coachs.accepted);
    },

    rejectedCoachs() {
      return this.filteredAttributionCoachs(this.coachs.rejected);
    },

    availableCoachs() {
      return this.filteredAttributionCoachs(this.coachs.available);
    },

    filteredCredit() {
      let credit = null;

      if (this.setCredit) {
        credit =
          this.form.credit === "manual"
            ? this.form.creditManual
            : this.form.credit;
        credit = parseFloat(credit.replace(",", ".")).toFixed(2) * 100;
      }

      return credit;
    },

    selectedWaitingCoach() {
      return this.coachsWaiting.filter((c) => c.checked);
    },

    coachsTotal() {
      return Object.values(this.coachs).reduce(
        (total, list) => total + list.length,
        0,
      );
    },
  },

  methods: {
    async refreshCoachs() {
      if (!this.attribution || !this.client) {
        return;
      }

      try {
        this.refreshing = true;

        const { data } = await this.$api.get(
          `/attributions/${this.attribution.id}/coachs`,
          {
            params: {
              email: this.client.email,
              appli: this.form.filterAppli,
              gender: this.form.filterGender,
              status: this.form.filterStatus.map((s) => s.value),
              sportsCoachOnly: this.form.filterSportsCoachOnly,
              prestations: this.form.filterPrestation.map((t) => t.value),
              tags: this.form.filterTags.map((t) => t.value),
              lang: this.form.filterLang,
              range: this.form.filterDelayed,
              credit: this.filteredCredit,
              availability: this.form.filterAvailability,
              periods: this.form.periods,
              rangeExtension: this.form.filterRangeExtension,
            },
          },
        );

        const allCoachs = [
          ...data.queue,
          ...data.accepted,
          ...data.rejected,
          ...data.available,
        ];
        const sorted = allCoachs
          .filter((c) => c.stats?.nbClients > 0)
          .sort((a, b) => b.stats.clientLongevity - a.stats.clientLongevity);

        const tier = Math.ceil(sorted.length / 3);
        const rankMap = new Map(
          sorted.map((c, i) => [
            c.id,
            i < tier ? "top" : i < tier * 2 ? "middle" : "bad",
          ]),
        );

        const addRank = (list) =>
          list.map((c) => {
            if (!c.stats || c.stats.clientLongevity == null) return c;
            return {
              ...c,
              stats: { ...c.stats, clientLongevityRank: rankMap.get(c.id) },
            };
          });

        this.coachs = {
          queue: addRank(data.queue),
          accepted: addRank(data.accepted),
          rejected: addRank(data.rejected),
          available: addRank(data.available),
          waiting: this.waitingCoachList(addRank(data.queue)),
        };

        this.updateAttributedCoachs();
      } catch (e) {
        this.$errorToast("Impossible de récupérer les coachs");
      } finally {
        this.refreshing = false;
      }
    },

    assignCoachConfirm(coach, credit) {
      this.$confirm({
        message: "Attribuer le coach sans attendre la réponse ?",
        onConfirm: async () => {
          try {
            this.loading = true;

            const { data } = await this.$api.patch(
              `/attributions/coach/${this.attribution.id}/attribute`,
              {
                email: coach.email,
              },
            );

            this.coachs.queue = this.coachs.queue.filter(
              (c) => c.id !== coach.id,
            );
            this.coachs.accepted.push(data);

            this.assignCoach(coach, credit);
          } catch (error) {
            this.$errorToast(
              "Une erreur est survenue lors de l'attribution du coach",
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },

    coachHasClient(coach) {
      return this.client.coachs.find((c) => c.id === coach.id);
    },

    async addCoach(coach) {
      try {
        this.loading = true;

        const { data } = await this.$api.post(
          `/attributions/coach/${this.attribution.id}`,
          {
            email: coach.email,
          },
        );

        const { distance, distanceSort } = this.coachs.available.find(
          (c) => c.id === data.id,
        );

        const addedCoach = {
          ...data,
          distance,
          distanceSort,
        };

        this.coachs.available = this.coachs.available.filter(
          (c) => c.id !== coach.id,
        );

        this.coachs.queue.push(addedCoach);
        this.waitingCoachList(this.coachs.queue);
      } catch (error) {
        this.$errorToast("Impossible d'ajouter le coach à l'attribution");
      } finally {
        this.loading = false;
      }
    },

    openRejectReasonModal(coach, rejectType) {
      this.coachEmailToReject = coach.email;
      this.rejectType = rejectType;
      this.isRejectReasonModalOpen = true;
    },

    removeCoach(coachId) {
      this.coachs.rejected.push(
        this.coachs.queue.find((c) => c.id === coachId),
      );

      this.coachs.queue = this.coachs.queue.filter((c) => c.id !== coachId);
    },

    async assignCoach(coach, credit) {
      if (this.setCredit === false) {
        credit = null;
      }

      this.$emit("assign", coach, credit);
    },

    async unassignCoach(coachId) {
      this.coachs.rejected.push(
        this.coachs.accepted.find((c) => c.id === coachId),
      );
      this.coachs.accepted = this.coachs.accepted.filter(
        (c) => c.id !== coachId,
      );
    },

    cleanCoachs() {
      this.$confirm({
        message: "Supprimer l'attribution pour tous les coachs ?",
        onConfirm: async () => {
          if (this.loading) {
            return;
          }

          try {
            this.loading = true;

            await this.$api.delete(
              `/attributions/coachs/${this.attribution.id}`,
            );

            this.coachs = {
              queue: [],
              accepted: [],
              rejected: [],
              available: [],
            };
          } catch (error) {
            this.$errorToast(
              "Une erreur est survenue lors de la suppression des coachs",
            );
          } finally {
            this.loading = false;

            this.refreshCoachs();
          }
        },
      });
    },

    async addSelectedCoachs() {
      if (
        this.loading ||
        !this.coachs.available ||
        this.coachs.available.length === 0
      ) {
        return;
      }

      try {
        this.loading = true;

        const emails = this.coachs.available.map((c) => c.email);

        const { data } = await this.$api.post(
          `/attributions/coachs/${this.attribution.id}`,
          {
            emails,
          },
        );

        this.coachs.available = this.coachs.available.filter(
          (c) => !emails.includes(c.email),
        );

        this.coachs.queue.push(...data);

        this.$toast.success("Les coachs ont été ajoutés à l'attribution");
      } catch (e) {
        this.$errorToast("Une erreur est survenue lors de l'ajout des coachs");
      } finally {
        this.loading = false;
      }
    },

    deleteAttribution() {
      this.$confirm({
        message: "Attention, cette action est irreversible !",
        onConfirm: async () => {
          if (this.loading) {
            return;
          }

          try {
            this.loading = true;

            await this.$api.delete(`/attributions/${this.attribution.id}`, {
              data: {
                clientId: this.client.id,
                coachInQueue: this.coachs.queue.length > 0,
              },
            });

            this.$router.push({ path: "/attributions" }, () => {
              window.location.reload(true);
            });
          } catch (e) {
            this.$errorToast("Impossible de supprimer l'attribution");
          } finally {
            this.loading = false;
          }
        },
      });
    },

    updateCredit() {
      this.$nextTick(
        debounce(() => {
          if (this.filteredCredit) {
            this.$api.post(`/attributions/credits/${this.attribution.id}`, {
              credit: this.filteredCredit,
            });
          }
        }, 1000),
      );
    },

    addPeriod() {
      if (
        this.form.filterAvailability !== "1" ||
        !this.period.start ||
        !this.period.end
      ) {
        return;
      }

      this.form.periods = this.form.periods || [];
      this.form.periods.push(this.period);

      this.period = {
        index: 0,
        start: null,
        end: null,
      };

      this.refreshCoachs();
    },

    removePeriod(index) {
      this.form.periods = this.form.periods || [];
      this.form.periods.splice(index, 1);

      this.refreshCoachs();
    },

    filteredAttributionCoachs(coachs) {
      if (this.filterCoach) {
        var regex = new RegExp(this.filterCoach, "i");
        coachs = coachs.filter((c) => c.name.match(regex));
      }

      return coachs.sort((a, b) => {
        if (a.distanceSort === undefined) {
          return 1;
        }

        if (b.distanceSort === undefined) {
          return -1;
        }

        return a.distanceSort > b.distanceSort
          ? 1
          : b.distanceSort > a.distanceSort
          ? -1
          : 0;
      });
    },

    async updateAttributedCoachs() {
      if (
        this.clientAttributions &&
        this.clientAttributions.length > 0 &&
        this.coachs &&
        this.coachs.accepted &&
        this.coachs.accepted.length > 0
      ) {
        const attributedCoachs = [
          ...new Set(this.clientAttributions.map((c) => c.user)),
        ];

        for (const coach of attributedCoachs) {
          const key = this.coachs.accepted.findIndex(
            (coachAccepted) => coachAccepted.email === coach,
          );

          if (key !== -1) {
            this.coachs.accepted[key].attributed = true;
          }
        }
      }
    },

    showWaitingCoachList() {
      this.isWaitingCoachsList = !this.isWaitingCoachsList;
    },

    filteredCoachsWaiting(coachs, userSearch) {
      const regex = new RegExp(userSearch, "i");

      coachs = coachs.filter((c) => c.name.match(regex));

      coachs.sort((a, b) => {
        if (a.distanceSort === undefined) {
          return 1;
        }

        if (b.distanceSort === undefined) {
          return -1;
        }

        return a.distanceSort > b.distanceSort
          ? 1
          : b.distanceSort > a.distanceSort
          ? -1
          : 0;
      });

      this.coachsWaiting = coachs;
    },

    waitingCoachList(coachs) {
      const validStatus = ["active", "inactive", "recruited"];

      const filterCoachs = coachs
        .filter((coach) => validStatus.includes(coach.status))
        .filter(
          (coach) =>
            parseInt(coach.distance?.distance.split(",")[0], 10) <=
            (parseInt(this.filterWaitingCoachByDistance, 10) || 15),
        )
        .map((coach) => {
          return {
            ...coach,
            checked: coach.checked !== undefined ? coach.checked : true,
          };
        })
        .sort((a, b) => {
          if (a.distanceSort === undefined) {
            return 1;
          }

          if (b.distanceSort === undefined) {
            return -1;
          }

          return a.distanceSort > b.distanceSort
            ? 1
            : b.distanceSort > a.distanceSort
            ? -1
            : 0;
        });

      this.coachsWaiting = filterCoachs;

      return filterCoachs;
    },

    addOrDeleteCoachWaitingList(toAdd, coachId) {
      const coachIndex = this.coachsWaiting.findIndex(
        (coach) => coach.id === coachId,
      );

      if (toAdd) {
        this.coachsWaiting[coachIndex].checked = true;
      }

      if (!toAdd) {
        this.coachsWaiting[coachIndex].checked = false;
      }
    },

  },
};
</script>

<style scoped lang="scss">
.periods {
  margin-top: 15px;
}

.periods label {
  padding: 5px;
}

.count-info {
  margin: 0 5px;
}

.custom-multiselect {
  .multiselect__tags {
    border-radius: 0;
    text-transform: capitalize;
    color: #9faecb;
  }
}

thead,
table.table {
  display: block;
  width: 100%;
  max-width: 100% !important;
}

tr {
  display: table;
  width: 100%;
  max-width: 100% !important;
}

tbody {
  display: block;
  width: 100%;
  max-width: 100% !important;
  max-height: 1200px;
  overflow: auto;
}
</style>
